<template>
  <el-form :model="ruleForm" label-width="90px" class="demo-ruleForm">
    <Span style="    text-align: center;
    width: 100%;
    color: red;
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    /* margin-top: -10px;">账号支持中文,字母和数字,注册后请牢记。</Span>
    <el-form-item label="账号">
      <input v-model="ruleForm.name" :placeholder="changepass?'输入修改的账号':'支持中文数字字母,长度至少5位'"></input>
    
    </el-form-item>
   
    <el-form-item label="手机">
      <input v-model.number="ruleForm.phone" :placeholder="changepass?'输入注册时预留的手机':'输入正确手机便于找回密码'"></input>
    </el-form-item>
    <el-form-item :label="changepass?'新密码':'输入密码'">
      <input v-model="ruleForm.pass" placeholder="长度至少6位"></input>
    </el-form-item>
    <el-form-item label="确认密码">
      <input v-model="ruleForm.pass2" placeholder="长度至少6位"></input>
    </el-form-item>
    <el-button type="primary" style="width:100%;margin-top:30px" @click="reg" :loading="loading">
      {{changepass?"修改密码":'注册'}}</el-button>

  </el-form>
</template>

<script>
  import https from "@/https.js";
  export default {
    props: ['changepass','f'],
    data() {

      return {
        ruleForm: {
          name: '',
          phone: '',
          pass: '',
          pass2: '',

        },
        yzm: '获取验证码',
        loading: false,
      };
    },
    created() {

    },
    methods: {
    
      reg() {

        if (this.ruleForm.name == "") {
          this.$message.error("账号不能为空");
          return;
        }
        if (this.ruleForm.name.length < 5) {
          this.$message.error("账号长度必须大于5位");
          return;
        }
        if (this.ruleForm.pass == "") {
          this.$message.error("密码不能为空");
          return;
        }
        if (this.ruleForm.pass.length < 6) {
          this.$message.error("密码长度必须大于6位");
          return;
        }
        if (this.ruleForm.pass2 == "") {
          this.$message.error("确认密码不能为空");
          return;
        }
        if (this.ruleForm.pass2 != this.ruleForm.pass) {
          this.$message.error("两次密码不一致");
          return;
        }
        else {
          let _this = this;
          var phone = this.ruleForm.phone;
          if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
            this.$message.error("手机号码不正确");
            return false;
          }
        }
        this.loading = true;

        https
          .fetchPost(this.changepass == true ? "https://zhushou.huasivip.com/admin/api/public/index/reg/changepass" : "https://zhushou.huasivip.com/admin/api/public/index/reg/create", { name: this.ruleForm.name, pass: this.ruleForm.pass, phone: this.ruleForm.phone,p:this.f ,ly:"bm"})
          .then(data => {

            if (data.data.code == 200) {
              this.loading = false;
              this.$message.success(data.data.msg);
              this.$emit("submit", this.ruleForm);
            } else {
              this.loading = false;
              this.$message.error(data.data.msg);
            }
          })
          .catch(err => {
            console.log(err);
          });

      },

    }
  }
</script>

<style scoped>
  input {

    HEIGHT: 30PX;

    -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 230px;
  }

  .login-container .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-color: white;
    border-radius: 5px;
    color: #454545;
  }

  .login-container .el-input input {
    background: white !important;
    border: 1px !important;

    border-radius: 2px !important;
    padding: 12px 5px 12px 15px !important;
    color: black !important;
    height: 36px !important;

  }
</style>


// WEBPACK FOOTER //
// src/components/login/reg.vue


// WEBPACK FOOTER //
// src/components/login/reg.vue